import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-modal-report',
  templateUrl: './confirmation-modal-report.component.html',
  styleUrls: ['./confirmation-modal-report.component.scss']
})
export class ConfirmationModalReportComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: string },
    private dialogRef: MatDialogRef<ConfirmationModalReportComponent>
  ) {}

  close(): void {
    this.dialogRef.close(true);
  }
}
